module.exports = __webpack_public_path__ + "img/news_api.2664e047.png";